"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCheck_1 = require("@fortawesome/pro-regular-svg-icons/faCheck");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var react_1 = __importDefault(require("react"));
var LinkCopierButton_1 = __importDefault(require("./LinkCopierButton"));
var StyledTextfield_1 = __importStar(require("./StyledTextfield"));
var LinkCopier = function (_a) {
    var text = _a.text, onCopy = _a.onCopy, hideText = _a.hideText, buttonLabelCopy = _a.buttonLabelCopy, buttonLabelCopied = _a.buttonLabelCopied, btnProps = __rest(_a, ["text", "onCopy", "hideText", "buttonLabelCopy", "buttonLabelCopied"]);
    var _b = __read(react_1.default.useState(false), 2), isCopied = _b[0], setIsCopied = _b[1];
    var copy = function () {
        navigator.clipboard.writeText(text);
        setIsCopied(true);
        if (onCopy)
            onCopy();
        setTimeout(function () { return setIsCopied(false); }, 3000);
    };
    var copyButton = ((0, jsx_runtime_1.jsx)(LinkCopierButton_1.default, __assign({ onClick: copy, icon: isCopied ? faCheck_1.faCheck : undefined, isSingle: hideText }, btnProps, { children: isCopied ? (buttonLabelCopied !== null && buttonLabelCopied !== void 0 ? buttonLabelCopied : 'Copied') : (buttonLabelCopy !== null && buttonLabelCopy !== void 0 ? buttonLabelCopy : 'Copy') })));
    if (hideText) {
        return copyButton;
    }
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row" }, { children: [(0, jsx_runtime_1.jsx)(StyledTextfield_1.InputWrapper, { children: (0, jsx_runtime_1.jsx)(StyledTextfield_1.default, { value: text, onFocus: function (event) { return event.target.select(); } }) }), copyButton] })));
};
exports.default = LinkCopier;
